import { createGlobalStyle } from 'styled-components';
import themeFonts from './themeFonts';

export const GlobalStyle = createGlobalStyle`
*,
*:before,
*:after {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-anchor: none;
}

html {
  font-size: 16px;
}

html,
body,
#root {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  height: 100%;
  min-height: 100%;
}

*,
body,
button,
input,
textarea,
select {
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

fieldset,
img {
  border: 0;
}

address,
caption,
cite,
code,
dfn,
em,
th, {
  font-style: normal;
  font-weight: normal;
}

ul {
  list-style: none;
}

caption,
th {
  text-align: left;
}

q:before,
q:after {
  content: '';
}

abbr,
acronym {
  border: 0;
}

svg {
  flex-shrink: 0;
}

textarea,
input:matches([type='email'], [type='number'], [type='password'], [type='search'], [type='tel'], [type='text'], [type='url']) {
  -webkit-appearance: none;

  &::-webkit-autofill,
  &::-webkit-contacts-auto-fill-button,
  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    user-select: none;
    display: none !important;
    position: absolute;
  }
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;

  &::-webkit-autofill,
  &::-webkit-contacts-auto-fill-button,
  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    user-select: none;
    display: none !important;
    position: absolute;
  }
}


input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
button,
input,
textarea,
p,
span,
blockquote,
th,
td {
  ${themeFonts}
}

p {
  vertical-align: middle;
  display: inline-block;
  word-break: break-word;
  font-size: 16px;
  line-height: 1.5;
}

span,
a {
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
}

a {
    cursor: pointer;
}

strong {
  font-weight: bold;
}
`;
